module.exports = __webpack_public_path__ + "static/media/mon-guerlain.c4dd5a69.png";